// old Description

import React from 'react'
import { useLangContext } from '../context/lang.context'
import Lines from './Lines'
import { s, colors, alpha, sDecoPath, sTextGradient } from '../style'
import Features from './Features'
import H from './H'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getImage } from 'gatsby-plugin-image'
import alt from '../content/alt'

const Main = ({ data, noDesktop, h, featuresRows }) => {
  const { lang } = useLangContext()

  const { title, texts, features, secondTexts, body } = data

  return (
    <section css={sSection}>
      <div css={sDecoPath}>
        <Lines />
      </div>
      <div css={sOuter}>
        {title && (
          <H h={h} css={sTitle}>
            {title[lang]}
          </H>
        )}
        <div css={features && sMargin}>
          {texts?.map((text, id) => (
            <Text key={id} id={id} text={text[lang]} />
          ))}

          {body?.map(({ headline, texts }, id) => (
            <React.Fragment key={id}>
              <H
                h={h === 1 && id === 0 ? 1 : 2}
                css={[sTitle, { marginTop: '2rem' }]}>
                {headline[lang]}
              </H>
              {texts?.map((text, id) => (
                <React.Fragment key={id}>
                  {text.image && (
                    <GatsbyImage
                      image={getImage(text.image)}
                      alt={headline[lang] + alt}
                      css={sImageSmall}
                    />
                  )}
                  <Text id={id} text={text[lang]} extraCss={sBodyText} />
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </div>
        <Features
          features={features}
          noDesktop={noDesktop}
          featuresRows={featuresRows}
        />
        <div>
          {secondTexts?.map((text, id) => (
            <React.Fragment key={id}>
              <div
                css={[sDecoText, id % 2 === 0 ? sDecoText.even : sDecoText.odd]}
              />
              <div
                key={id}
                css={[sText, id % 2 === 0 ? sText.even : sText.odd]}
                dangerouslySetInnerHTML={{ __html: text[lang] }}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  )
}

const Text = ({ id, text, extraCss }) => (
  <>
    <p
      css={[sText, id % 2 === 0 ? sText.even : sText.odd, extraCss]}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
    <p css={[sDecoText, id % 2 === 0 ? sDecoText.even : sDecoText.odd]} />
  </>
)

const sBodyText = {
  ul: { margin: '1.5rem 0 1.5rem 1.5rem' },
  a: {
    fontWeight: 700,
    textDecoration: 'underline',
    color: colors.brandLight,
    '&:hover': {
      color: colors.white,
    },
  },
  [s.md]: {
    span: { width: '80%' },
  },
}

const sSection = {
  position: 'relative',
  zIndex: 5,
  background: `linear-gradient(180deg, ${colors.greyDarker}, ${colors.greyDark})`,
  [s.sm_down]: {
    left: 0,
    top: -1,
    borderRadius: '0 0 2rem 2rem',
  },
  [s.md]: {
    borderRadius: '0px 0px 128px 128px',
  },
  color: colors.white,
  boxShadow: `0px 16px 64px ${colors.black.concat(alpha[30])}`,
}

const sOuter = {
  width: '100vw',
  maxWidth: 1500,
  padding: '6rem 2rem 4rem',
  margin: '0 auto',
  [s.xs]: {
    padding: '4rem 2rem 1rem',
  },
  [s.md]: {
    padding: '6rem 4rem 4rem',
  },
  zIndex: 1,
  position: 'relative',
  top: 0,
  left: 0,
}

const sTitle = {
  ...sTextGradient,
  margin: 0,
  zIndex: 2,
  width: 'max-content',
  maxWidth: '100%',
  textAlign: 'left',
  fontSize: '3rem',
  letterSpacing: '-0.05em',
  padding: '4rem 0 0',
  // marginBottom: '4rem',
  fontWeight: 700,
  [s.sm_down]: {
    fontSize: '2.5rem',
    width: '100%',
    padding: '4rem 0rem 0rem',
    marginBottom: 0,
  },
}

const sText = {
  lineHeight: '2em',
  [s.sm_down]: {
    fontSize: '1rem',
  },
  [s.md]: {
    fontSize: '1.125rem',
    span: {
      width: '60%',
    },
  },
  [s.lg]: {
    fontSize: '1.25rem',
  },

  color: colors.white.concat(alpha[60]),
  strong: {
    color: colors.white.concat(alpha[100]),
    fontWeight: 700,
  },

  even: {
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  odd: {
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },

  a: {
    color: '#2b2c69',
  },

  margin: '4rem 0',
}

const sDecoText = { 
  height: 2,
  width: '100vw',
  top: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  position: 'relative',
  even: {
    background: `linear-gradient(to right, ${
      colors.brandLight
    }, ${colors.brand.concat(alpha[0])} 60%)`,
  },
  odd: {
    background: `linear-gradient(to left, ${
      colors.brandLight
    }, ${colors.brand.concat(alpha[0])} 60%)`,
  },
}

const sImageSmall = {
  borderRadius: '1rem',
  marginTop: '4rem',
  backgroundColor: colors.greyDark,
  img: {
    borderRadius: '1rem',
  },
}

const sMargin = {
  marginBottom: '10%',
}

export default Main
